"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = exports.Tab = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const TabContainer = styled_components_1.default.a `
  align-items: center;
  background-color: ${(props) => props.primary
    ? props.theme.colors.white
    : props.theme.colors.backgroundInactive};
  border-radius: ${(props) => (props.primary ? '0px' : '100px')};
  color: ${(props) => props.theme.colors.textDefault};
  cursor: pointer;
  display: inline-flex;
  flex: 1 1 0px;
  height: 3rem;
  justify-content: center;
  padding: 0 ${(props) => props.theme.spacing.s};
  text-align: center;
  text-decoration: none;
  transition: background-color 200ms ease, color 200ms ease;

  &:focus-visible {
    outline: ${(props) => props.theme.outline};
    outline-offset: 1px;
    z-index: 1;
  }
  ${(props) => props.active &&
    `
    &, &:hover, &:active {
      background-color: ${props.theme.colors.primaryAccent};
      color: ${props.theme.colors.white};
    }
  `}
  ${(props) => props.active &&
    props.primary &&
    !props.vertical &&
    `
    &, &:hover, &:active {
      background-color: ${props.theme.colors.backgroundPrimaryAccent};
      color: ${props.theme.colors.textNavigation};
      border-bottom: 2px solid  ${props.theme.colors.primaryAccent}
    }
  `}
      ${(props) => !props.primary &&
    props.vertical &&
    `
    &, &:hover, &:active {
      background-color: none;
    }
  `}
      ${(props) => props.active &&
    props.disabled &&
    `
    &, &:hover, &:active {
      background-color: ${props.theme.colors.primaryAccentLight};
    }
  `}
      ${(props) => props.disabled &&
    `
    color: ${props.theme.colors.textInactive};
    pointer-events: none;
  `}
      ${(props) => props.primary &&
    props.active &&
    `
    color: ${props.theme.colors.textDefault};
  `}
      ${(props) => props.primary &&
    props.active &&
    props.vertical &&
    `
    &, &:hover, &:active {
      background-color: ${props.theme.colors.backgroundPrimaryAccent};
      color: ${props.theme.colors.textNavigation};
      border-right: 2px solid  ${props.theme.colors.primaryAccent}
  `};
`;
const Label = styled_components_1.default.span `
  display: inline-block;
  border: none;
  transition: color 200ms ease;
  user-select: none;

  &:focus {
    outline: none;
  }
`;
const Tab = ({ active = false, children, className, disabled = false, href = '#', id, onClick, style, primary = false, vertical = false, }) => (react_1.default.createElement(TabContainer, { active: active, "aria-disabled": disabled, "aria-selected": active, className: className, disabled: disabled, href: href, id: id, primary: primary, vertical: vertical, onClick: (event) => {
        if (onClick && href === '#') {
            event.preventDefault();
            onClick();
        }
    }, role: "tab", style: style },
    react_1.default.createElement(Label, { disabled: disabled, active: active }, children)));
exports.Tab = Tab;
const TabsContainer = styled_components_1.default.div `
  background-color: ${(props) => !props.vertical && props.theme.colors.backgroundInactive};
  border-radius: 100px;

  display: flex;
  justify-content: space-between;
  flex-direction: ${(props) => (props.vertical ? 'column' : 'row')};

  ${(props) => props.vertical &&
    `
    & > a > span {
      height: 3rem;
      padding: 1rem;
      margin-bottom: 10px;
    }
  `}

  ${(props) => props.vertical &&
    !props.primary &&
    `
    & > a  {
      margin-bottom: 15px;
    }
    `}
`;
const Tabs = ({ activeTabKey, children, className, disabled = false, id, onTabClick, style, vertical = false, primary = false, }) => (react_1.default.createElement(TabsContainer, { className: className, id: id, role: "tablist", style: style, vertical: vertical, primary: primary, activeTabKey: activeTabKey }, react_1.default.Children.map(children, (child) => (react_1.default.createElement(react_1.default.Fragment, { key: `tab-${child.props.tabKey}` }, react_1.default.cloneElement(child, {
    active: activeTabKey === child.props.tabKey,
    disabled: disabled || child.props.disabled,
    vertical: vertical || child.props.vertical,
    primary: primary || child.props.primary,
    onClick: onTabClick
        ? () => onTabClick(child.props.tabKey)
        : undefined,
}))))));
exports.Tabs = Tabs;
